import React from 'react';
import { Icon } from 'common/icon';
import styles from './styles.module.css';

interface SearchInputProps {
  onSearchChange: (value: string) => void;
}

export const SearchInput = ({ onSearchChange }: SearchInputProps) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  return (
    <div className={styles.searchContainer}>
      <Icon.Search width="18" height="18" />
      <input
        type="text"
        className={styles.input}
        placeholder="Country"
        onChange={handleInputChange}
      />
    </div>
  );
};
